export const API_URL = process.env.REACT_APP_API_URL;
export const TOKEN_URL = process.env.REACT_APP_TOKEN_URL;
